import { GRUPOS_COPA_2026, nomeTime } from '../data/copaMundo2026';

/** Converte código ISO 3166-1 alpha-2 em emoji de bandeira. */
export function isoParaEmoji(iso: string): string {
  const u = iso.toUpperCase();
  if (u.length !== 2) return '';
  const base = 0x1f1e6;
  return [...u]
    .map((c) => String.fromCodePoint(base + c.charCodeAt(0) - 65))
    .join('');
}

/** ISO 3166-1 alpha-2 (minúsculo) para emoji na tela e imagens na impressão. */
const ISO_POR_TIME: Record<string, string> = {
  MEX: 'mx',
  RSA: 'za',
  KOR: 'kr',
  CZE: 'cz',
  CAN: 'ca',
  BIH: 'ba',
  QAT: 'qa',
  SUI: 'ch',
  BRA: 'br',
  MAR: 'ma',
  HAI: 'ht',
  SCO: 'gb',
  USA: 'us',
  PAR: 'py',
  AUS: 'au',
  TUR: 'tr',
  GER: 'de',
  CUW: 'cw',
  CIV: 'ci',
  ECU: 'ec',
  NED: 'nl',
  JPN: 'jp',
  SWE: 'se',
  TUN: 'tn',
  BEL: 'be',
  EGY: 'eg',
  IRN: 'ir',
  NZL: 'nz',
  ESP: 'es',
  CPV: 'cv',
  KSA: 'sa',
  URU: 'uy',
  FRA: 'fr',
  SEN: 'sn',
  IRQ: 'iq',
  NOR: 'no',
  ARG: 'ar',
  ALG: 'dz',
  AUT: 'at',
  JOR: 'jo',
  POR: 'pt',
  COD: 'cd',
  UZB: 'uz',
  COL: 'co',
  ENG: 'gb',
  CRO: 'hr',
  GHA: 'gh',
  PAN: 'pa',
};

const EMOJI_BANDEIRA_POR_TIME: Record<string, string> = Object.fromEntries(
  Object.entries(ISO_POR_TIME).map(([id, iso]) => [id, isoParaEmoji(iso.toUpperCase())])
);

function normTexto(s: string): string {
  return String(s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

/** Código FIFA em maiúsculas (BRA, MEX…). */
export function normalizarTimeIdCodigo(raw: string): string {
  return String(raw || '').trim().toUpperCase();
}

/** Acha o código do time pelo nome exibido (ex.: "Marrocos" → MAR). */
export function timeIdPorNomeRotulo(rotulo: string): string {
  const alvo = normTexto(rotulo);
  if (!alvo) return '';
  for (const g of GRUPOS_COPA_2026) {
    for (const tm of g.times) {
      if (normTexto(tm.nome) === alvo) return tm.id;
    }
  }
  return '';
}

/** Resolve código para bandeira: timeId publicado ou nome do confronto. */
export function resolverTimeIdParaBandeira(timeId: string, rotulo?: string): string {
  const cod = normalizarTimeIdCodigo(timeId);
  if (ISO_POR_TIME[cod]) return cod;
  if (rotulo) {
    const porNome = timeIdPorNomeRotulo(rotulo);
    if (porNome) return porNome;
  }
  return cod;
}

export function bandeiraTime(timeId: string): string {
  return EMOJI_BANDEIRA_POR_TIME[normalizarTimeIdCodigo(timeId)] ?? '';
}

/** Retorna a URL da imagem da bandeira (flagcdn.com). Funciona em qualquer navegador. */
export function urlBandeira(timeId: string, largura: 20 | 40 | 80 | 160 = 40): string {
  const iso = ISO_POR_TIME[normalizarTimeIdCodigo(timeId)];
  return iso ? `https://flagcdn.com/w${largura}/${iso}.png` : '';
}

/** Bandeira como imagem (impressão/PDF — emoji costuma virar sigla MX, BR…). */
export function htmlTimeImpressao(
  timeId: string,
  escapar: (s: string) => string,
  lado?: 'mandante' | 'visitante'
): string {
  const nome = escapar(nomeTime(timeId));
  const iso = ISO_POR_TIME[normalizarTimeIdCodigo(timeId)];
  const img = iso
    ? `<img class="flag" src="https://flagcdn.com/w40/${iso}.png" alt="" width="24" height="17" />`
    : '';
  const cls = lado ? `linha-time ${lado}` : 'linha-time';
  return `<span class="${cls}">${img}<span class="nome-time">${nome}</span></span>`;
}

export function rotuloTime(timeId: string, comBandeira = true): string {
  const nome = nomeTime(timeId);
  if (!comBandeira) return nome;
  const bandeira = bandeiraTime(timeId);
  return bandeira ? `${bandeira} ${nome}` : nome;
}
